import { BrowserRouter, Route, Routes } from "react-router-dom";
import { GlobalProvider } from "./context/GlobalContext";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import HomePageOne from "./pages/HomePageOne";
import HomePageTwo from "./pages/HomePageTwo";
import HomePageThree from "./pages/HomePageThree";
import ShopPage from "./pages/ShopPage";
import ProductDetailsPageOne from "./pages/ProductDetailsPageOne";
import ProductDetailsPageTwo from "./pages/ProductDetailsPageTwo";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import OrderConfirmationPage from "./pages/OrderConfirmationPage";
import OrderDetailsPage from "./pages/OrderDetailsPage";
import AccountPage from "./pages/AccountPage";
import BlogPage from "./pages/BlogPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import ContactPage from "./pages/ContactPage";
import AboutPage from "./pages/AboutPage";
import PhosphorIconInit from "./helper/PhosphorIconInit";
import Animation from "./helper/Animation";
import VendorPage from "./pages/VendorPage";
import VendorDetailsPage from "./pages/VendorDetailsPage";
import VendorTwoPage from "./pages/VendorTwoPage";
import VendorTwoDetailsPage from "./pages/VendorTwoDetailsPage";
import BecomeSellerPage from "./pages/BecomeSellerPage";
import WishlistPage from "./pages/WishlistPage";
import AuthPage from "./pages/AuthPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import TermsConditionsPage from "./pages/TermsConditionsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import ShippingPolicyPage from "./pages/ShippingPolicyPage";
import RefundPolicyPage from "./pages/RefundPolicyPage";
import PoliciesHubPage from "./pages/PoliciesHubPage";
import { Toaster } from "react-hot-toast";
import FloatingWidgets from "./components/FloatingWidgets";

function App() {
  return (
    <GlobalProvider>
      <BrowserRouter>
        <RouteScrollToTop />
        <PhosphorIconInit />
        <Animation />
        <FloatingWidgets />
        <Toaster
          position="top-center"
          toastOptions={{ duration: 2500, style: { zIndex: 99999999 } }}
          containerStyle={{ zIndex: 99999999 }}
        />

        <Routes>
          <Route exact path='/' element={<HomePageOne />} />
          <Route exact path='/index-two' element={<HomePageTwo />} />
          <Route exact path='/index-three' element={<HomePageThree />} />
          <Route exact path='/shop' element={<ShopPage />} />
          <Route exact path='/shop/:slug' element={<ShopPage />} />
          <Route
            path='/product-details'
            element={<ProductDetailsPageOne />}
          />
          <Route
            path='/product-details/:id'
            element={<ProductDetailsPageOne />}
          />
          <Route
            exact
            path='/product-details-two'
            element={<ProductDetailsPageTwo />}
          />
          <Route exact path='/cart' element={<CartPage />} />
          <Route exact path='/checkout' element={<CheckoutPage />} />
          <Route exact path='/order-confirmation/:id' element={<OrderConfirmationPage />} />
          <Route exact path='/order-confirmation' element={<OrderConfirmationPage />} />
          <Route exact path='/thank-you/:id' element={<OrderConfirmationPage />} />
          <Route exact path='/order-details/:id' element={<OrderDetailsPage />} />
          <Route exact path='/order-details' element={<OrderDetailsPage />} />
          <Route exact path='/account/orders/:id' element={<OrderDetailsPage />} />
          <Route exact path='/become-seller' element={<BecomeSellerPage />} />
          <Route exact path='/wishlist' element={<WishlistPage />} />
          <Route exact path='/account' element={<AccountPage />} />
          <Route exact path='/blog' element={<BlogPage />} />
          <Route exact path='/blog-details' element={<BlogDetailsPage />} />
          <Route exact path='/blog/:slug' element={<BlogDetailsPage />} />
          <Route exact path='/contact' element={<ContactPage />} />
          <Route exact path='/about' element={<AboutPage />} />
          <Route exact path='/terms-and-conditions' element={<TermsConditionsPage />} />
          <Route exact path='/terms' element={<TermsConditionsPage />} />
          <Route exact path='/privacy-policy' element={<PrivacyPolicyPage />} />
          <Route exact path='/privacy' element={<PrivacyPolicyPage />} />
          <Route exact path='/shipping-policy' element={<ShippingPolicyPage />} />
          <Route exact path='/shipping-delivery-policy' element={<ShippingPolicyPage />} />
          <Route exact path='/refund-policy' element={<RefundPolicyPage />} />
          <Route exact path='/return-refund-policy' element={<RefundPolicyPage />} />
          <Route exact path='/cancellation-return-refund-policy' element={<RefundPolicyPage />} />
          <Route exact path='/policies' element={<PoliciesHubPage />} />
          <Route exact path='/login' element={<AuthPage pageTitle="Login" />} />
          <Route exact path='/register' element={<AuthPage pageTitle="Create Account" />} />
          <Route exact path='/forgot-password' element={<ForgotPasswordPage />} />
          <Route exact path='/reset-password' element={<ForgotPasswordPage />} />
          <Route exact path='/vendor' element={<VendorPage />} />
          <Route exact path='/vendor-details' element={<VendorDetailsPage />} />
          <Route exact path='/vendor-two' element={<VendorTwoPage />} />
          <Route
            exact
            path='/vendor-two-details'
            element={<VendorTwoDetailsPage />}
          />
        </Routes>
      </BrowserRouter>
    </GlobalProvider>
  );
}

export default App;
